<template>
  <div class="home">
    <el-container style="width:auto;">
      <el-aside style="width: auto;">
        <side-bar></side-bar>
      </el-aside>
      <el-container >
        <el-header style="padding: 0;">
          <nav-bar></nav-bar>
          <!-- <tag-nav></tag-nav> -->
        </el-header>
        <el-main class="mainBox">
          <transition name="el-zoom-in-top"
                      mode="out-in"
                      appear>
            <router-view></router-view>
          </transition>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import axios from 'axios';
import SideBar from './sidebar'
import NavBar from './Navbar'
import TagNav from './tagnav'

export default {
  components: {
    SideBar,
    NavBar,
    TagNav
  },
  data () {
    return {
      side: true,
      arr: []
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<style>
.home {
  width: 100%;
  height: 100%;
  display: flex;
}
.home-left {
  flex-shrink: 0;
}
.home-right {
  width: 100%;
  flex-shrink: 1;
}
.el-header {
  height: auto !important;
}
.el-main {
  padding: 0 !important;
}
body {
  overflow: hidden;
}
.el-container {
  /* height: 100vh; */
}

.el-aside::-webkit-scrollbar{

display: none;

}

.mainBox{
  width: 100%;
  margin: auto;
}
</style>
